<div
  class="upload-banner"
  *ngIf="state as s"
  [class.upload-banner--done]="s.phase === 'done'"
  [class.upload-banner--stopped]="s.phase === 'stopped'"
  [class.upload-banner--asking]="confirmingStop && s.phase === 'uploading'"
  [class.upload-banner--behind-dialog]="dialogOpen"
  role="status"
  aria-live="polite">

  <!-- ✕ on a running upload: the dialog's question, in the strip. -->
  <div class="upload-banner__ask" *ngIf="confirmingStop && s.phase === 'uploading'; else strip"
    role="alertdialog" aria-labelledby="uploadBannerAskTitle" aria-describedby="uploadBannerAskBody">
    <p id="uploadBannerAskTitle" class="upload-banner__ask-title">{{ stopTitle(s) }}</p>
    <p id="uploadBannerAskBody" class="upload-banner__ask-body">{{ stopBody(s.isHost) }}</p>
    <div class="upload-banner__ask-actions">
      <button #keepBtn type="button" class="upload-banner__btn upload-banner__btn--keep" (click)="keepUploading()">{{ keepLabel }}</button>
      <button type="button" class="upload-banner__btn upload-banner__btn--stop" (click)="stopUpload()">{{ stopLabel }}</button>
    </div>
  </div>

  <ng-template #strip>
  <button
    type="button"
    class="upload-banner__body"
    (click)="openDialog()"
    [attr.aria-label]="s.phase === 'done' ? 'Upload finished. View the ' + (s.isHost ? 'album' : 'Event Gallery') : (s.phase === 'stopped' ? 'Add the photos again' : 'Open upload progress')">

    <span class="upload-banner__icon" aria-hidden="true">
      <span class="upload-banner__spinner" *ngIf="s.phase === 'uploading' || s.phase === 'processing'"></span>
      <svg *ngIf="s.phase === 'done'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
        stroke-linecap="round" stroke-linejoin="round">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
      <svg *ngIf="s.phase === 'stopped'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="9"></circle>
        <line x1="12" y1="8" x2="12" y2="12.5"></line>
        <line x1="12" y1="16" x2="12.01" y2="16"></line>
      </svg>
    </span>

    <!-- The two legs are named separately on purpose. Reporting only backend
         completion made a batch whose files had all landed read "0 of 10",
         which is exactly what a failed upload looks like. -->
    <span class="upload-banner__text">
      <span class="upload-banner__title">
        <ng-container *ngIf="s.stopping && s.phase !== 'done'; else phaseTitle">{{ stoppingTitle }}</ng-container>
        <ng-template #phaseTitle>
          <ng-container [ngSwitch]="s.phase">
            <ng-container *ngSwitchCase="'done'">{{ doneTitle(s.failed, s.stopped) }}</ng-container>
            <ng-container *ngSwitchCase="'processing'">Getting {{ s.eventName }} ready</ng-container>
            <ng-container *ngSwitchCase="'stopped'">Upload to {{ s.eventName }} stopped</ng-container>
            <ng-container *ngSwitchDefault>Uploading to {{ s.eventName }}</ng-container>
          </ng-container>
        </ng-template>
      </span>
      <!-- Wraps in the state that carries a sentence rather than a count. -->
      <span class="upload-banner__subtitle"
        [class.upload-banner__subtitle--wrap]="s.phase === 'stopped'">
        <ng-container *ngIf="s.stopping && s.phase !== 'done'; else normalSubtitle">{{ stoppingNote }}</ng-container>
        <ng-template #normalSubtitle>
          <ng-container [ngSwitch]="s.phase">
            <ng-container *ngSwitchCase="'done'">{{ doneSubtitle(s.completed, s.total, s.failed, s.eventName, s.stopped) }}</ng-container>
            <ng-container *ngSwitchCase="'processing'">
              {{ s.completed }} of {{ s.total }} ready
            </ng-container>
            <ng-container *ngSwitchCase="'stopped'">{{ stoppedText(s.remaining) }} {{ stoppedAction }}</ng-container>
            <ng-container *ngSwitchDefault>{{ s.uploaded }} of {{ s.total }} uploaded · {{ keepOpenText }}</ng-container>
          </ng-container>
          <ng-container *ngIf="s.failed && s.phase !== 'stopped' && s.phase !== 'done'"> · {{ s.failed }} didn't upload</ng-container>
        </ng-template>
      </span>
    </span>

    <span class="upload-banner__pct" *ngIf="s.phase !== 'stopped' && s.phase !== 'done'">{{ s.percent }}%</span>
  </button>

  <button type="button" class="upload-banner__close" aria-label="Dismiss" (click)="dismiss($event)">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  </button>
  </ng-template>

  <div class="upload-banner__track" *ngIf="s.phase !== 'stopped'">
    <div class="upload-banner__fill" [style.width.%]="s.percent"></div>
  </div>
</div>
